/* eslint-disable no-unused-vars */
import { Label, Table } from '../../../../Components/uielements';
import {
  IconButton,
  ModalButtonWrapper,
  ModalGap,
  OutlineButton,
  TableCell,
  TableWrapper,
} from '../../../../services/settings/appStyle/global.style';
import { IntlMessages } from '../../../../helper/langHelper';
import { useUserContext } from '../../../../hooks/UserContext';
import { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { EyeIcon } from '../../../../Components/icons';
import ChildModal from '../../../../Components/uielements/modal/childModal';
import { getCheckListResponsesList } from '../../../../services/bioplus-services/checkList';
import { ModalWrapper } from '../../EmailTemplate/emailTemplate.style';
import ViewCheckListAnswers from './viewCheckListAnswers';

import { convertToUserTimeZoneDateTime } from '../../../../helper/dataFormat';

const CheckListViewResponse = ({ onClose, questionnaireId, companyId }) => {
  const userContext = useUserContext();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectedInvite, setSelectedInvite] = useState(undefined);

  const query = useQuery(['checklist-responses', questionnaireId, page, pageSize], () =>
    getCheckListResponsesList(page, pageSize, { questionnaireId, companyId })
  );

  const checklistResponses = query?.data?.responseList || [];

  const userTimeZone = useMemo(() => Intl.DateTimeFormat().resolvedOptions().timeZone, []);

  const checklistColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.name" />,
        accessor: 'userName',
        Cell: (cellData) => (
          <TableCell>
            {`${cellData?.row?.original?.userId?.firstName} ${cellData?.row?.original?.userId?.lastName}`}
          </TableCell>
        ),
        width: '35%',
      },
      {
        Header: <IntlMessages id="table.col.createdAt" defaultMessage="Created At" />,
        accessor: 'createdAt',
        width: '40%',
        Cell: (cellData) => (
          <TableCell>
            {cellData.value ? convertToUserTimeZoneDateTime(cellData?.value, userTimeZone) : '--'}
          </TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.actions" />,
        accessor: 'actions',
        isAction: true,
      },
    ],
    []
  );

  const actionList = [
    (data) => (
      <IconButton onClick={() => setSelectedInvite(data)}>
        <EyeIcon style={{ width: '19px', height: '19px' }} />
      </IconButton>
    ),
  ];

  const handleNextPage = () => {
    setPage((value) => value + 1);
  };

  const handlePreviousPage = () => {
    setPage((value) => value - 1);
  };

  return (
    <>
      <ChildModal
        isOpen={true}
        onClose={onClose}
        title={<IntlMessages id="modal.text.checklist.responses" />}
      >
        {query.isLoading ? (
          <ModalWrapper>
            <Label>
              <IntlMessages id="loading.text" />
            </Label>
          </ModalWrapper>
        ) : query.isError ? (
          <ModalWrapper>
            <Label>
              <IntlMessages id="error.message" />
            </Label>
            <OutlineButton onClick={onClose}>
              <IntlMessages id="modal.button.cancel" />
            </OutlineButton>
          </ModalWrapper>
        ) : (
          <ModalWrapper>
            <ModalGap>
              <TableWrapper>
                <Table
                  data={checklistResponses}
                  columns={checklistColumns}
                  hasFooter={true}
                  page={page}
                  pageSize={pageSize}
                  prevPage={handlePreviousPage}
                  nextPage={handleNextPage}
                  total={checklistResponses?.length || 0}
                  actions={actionList}
                  isActionsRenderConditinal={true}
                />
              </TableWrapper>
            </ModalGap>
            <ModalButtonWrapper>
              <OutlineButton onClick={onClose}>
                <IntlMessages id="modal.button.close" />
              </OutlineButton>
            </ModalButtonWrapper>
          </ModalWrapper>
        )}
      </ChildModal>
      {selectedInvite && (
        <ViewCheckListAnswers
          onClose={() => setSelectedInvite(undefined)}
          inviteId={selectedInvite?._id}
        />
      )}
    </>
  );
};

export default CheckListViewResponse;
